module.exports = __webpack_public_path__ + "img/56.5.COD.8015e850.png";